<p>users-ntf-list-side-filter works!</p>
